export const reportTypes = {
  PLAYERS: 'report/PLAYERS',
  PLAYERS_RES: 'report/PLAYERS_RES',
  SAVE_URL: 'report/SAVE_URL'
}

export const getPlayersReport = (city) => (
  {
    type: reportTypes.PLAYERS,
    city
  }
)



// WEBPACK FOOTER //
// ./src/actions/reports.js